import { Check } from '@music-vine/cadence/icons';
import type React from 'react';
import Marquee from 'react-fast-marquee';
import PlatformIcons from '@/components/Icons/PlatformIcons';
import { Badge } from '@music-vine/cadence/ui';
const contentTypes = ['Social media', 'Livestreams', 'Podcasts', 'Websites'];

// Reusable container component
const SafetySection: React.FC<{
  titleHighlight: string;
  children: React.ReactNode;
}> = ({
  titleHighlight,
  children
}) => <div className="flex w-full flex-col items-center justify-center gap-8 rounded-2xl" data-sentry-component="SafetySection" data-sentry-source-file="SafeForAllPlatformsSection.tsx">
    <h2 className="px-6 text-center font-aeonik font-semibold text-lg dark:text-white">
      Safe for <span className="text-pink-500">{titleHighlight}</span>
    </h2>
    {children}
  </div>;

// Main component using the reusable container
export const SafeForAllPlatformsSection = () => {
  return <div className="flex flex-col items-center justify-center gap-10 2xl:mx-0" data-sentry-component="SafeForAllPlatformsSection" data-sentry-source-file="SafeForAllPlatformsSection.tsx">
      {/* Platforms Section */}
      <SafetySection titleHighlight="all platforms" data-sentry-element="SafetySection" data-sentry-source-file="SafeForAllPlatformsSection.tsx">
        <PlatformIcons className="hidden lg:flex" data-sentry-element="PlatformIcons" data-sentry-source-file="SafeForAllPlatformsSection.tsx" />
        <div className="block text-white lg:hidden dark:text-gray-950">
          <Marquee gradient gradientColor="currentColor" gradientWidth={40} data-sentry-element="Marquee" data-sentry-source-file="SafeForAllPlatformsSection.tsx">
            <PlatformIcons className="text-gray-950 dark:text-white" data-sentry-element="PlatformIcons" data-sentry-source-file="SafeForAllPlatformsSection.tsx" />
          </Marquee>
        </div>
      </SafetySection>

      {/* Content Type Section */}
      <ul className="m-0 flex w-full list-none flex-wrap justify-center gap-4 p-0">
        {contentTypes.map(type => <li className="m-0 p-0" key={type}>
            <Badge className="flex items-center gap-1 border-gray-50 bg-gray-50 font-sans text-gray-700 text-sm dark:border-gray-800 dark:text-white" variant="light">
              <Check className="size-4 text-green-500" /> {type}
            </Badge>
          </li>)}
      </ul>
    </div>;
};
export default SafeForAllPlatformsSection;